import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as PrevIcon } from 'Images/prev.svg';
import { ReactComponent as IconVulnerability_ } from 'Images/vulnerabilities.svg';
import { ReactComponent as IconAsset_, ReactComponent as IconService_ } from 'Images/assets.svg';
import { ReactComponent as EmptyFolder_ } from 'Images/empty-folder.svg';
import { ReactComponent as UngroupIcon_ } from 'Images/ungroup-icon.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 37px;
  padding: 0 10px;
  margin-bottom: 9px;
  border-bottom: 1px solid ${({ theme }) => theme?.mode === 'light' ? colors.light3 : 'transparent'};
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 10px;
`;

export const BackButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: ${({ theme }) => theme?.links?.primary ?? '#1d4ed8'};
  padding: 4px 6px;

  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.text.tableVulnNameConfirmed};
  
`;

export const ActionButton = styled.button`
  border: 1px solid ${({ theme }) => theme?.borders?.light ?? '#dfe1e6'};
  background: ${({ disabled }) => (disabled ? '#f4f5f7' : '#ffffff')};
  color: ${({ disabled }) => (disabled ? '#97a0af' : '#172b4d')};
  padding: 6px 10px;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const WrapperButton = styled.button`
  border: 0;
  background: transparent;
  width: ${({ small }) => small ? '23px' : '37px'};
  height: ${({ small }) => small ? '23px' : '37px'};
  background-color: transparent;
  margin: 0 0 0 8px;

  &:hover:not(:disabled) {
    & > svg circle {
      fill: ${({ theme }) => theme.buttons.pagination.background};
    }
  }

  &:disabled {
    & > svg {
      cursor: default;
    }
    & > svg circle {
      fill: transparent;
    }
    & > svg path {
      fill: ${colors.grey12};
    }
  }
`;
WrapperButton.displayName = 'WrapperButton';

export const Prev = styled(PrevIcon)`
  width: ${({ small }) => small ? '23px' : '37px'};
  height: ${({ small }) => small ? '23px' : '37px'};
  & > g circle {
    fill: transparent;
  }

  & > g path {
    fill: ${({ theme }) => theme?.icons?.actionBar?.color ?? '#6b778c'};
  }
`;
Prev.displayName = 'Prev';

export const IconVulnerability = styled(IconVulnerability_).attrs({
  viewBox: '0 0 21 22',
  preserveAspectRatio: 'xMidYMid meet'
})`
  margin-right: 11px !important;
  height: 18px;
  width: 18px;
  min-height: 18px;
  min-width: 18px;
  flex: 0 0 auto;
  overflow: visible;
  cursor: default;
  pointer-events: none;
  &,
  & * {
    cursor: default !important;
  }
  path {
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke: ${({ theme }) => theme.icons.detailModalTitle.color};
    vector-effect: non-scaling-stroke;
  }
`;
IconVulnerability.displayName = 'IconVulnerability_';

export const FolderIcon = styled(EmptyFolder_)`
  margin-right: 11px !important;
  height: 18px;
  width: 18px;
  cursor: default;
  pointer-events: none;
  &,
  & * {
    cursor: default !important;
  }

  & path { fill: ${({ theme }) => theme.icons.actionBar.color}; }
  & g path { fill: ${({ theme }) => theme.icons.actionBar.color}; }
  & * { stroke: ${({ theme }) => theme.icons.actionBar.color}; }
`;
FolderIcon.displayName = 'FolderIcon';

export const IconAsset = styled(IconAsset_)`
  margin-right: 11px !important;
  height: 18px;
  width: 18px;
  min-height: 18px;
  min-width: 18px;
  flex: 0 0 auto;
  overflow: visible;
  cursor: default;
  pointer-events: none;
  &,
  & * {
    cursor: default !important;
  }
  path {
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke-width: 0.2;
    vector-effect: non-scaling-stroke;
  }
`;
IconAsset.displayName = 'IconAsset_';

export const IconService = styled(IconService_)`
  margin-right: 11px !important;
  height: 18px;
  width: 18px;
  min-height: 18px;
  min-width: 18px;
  flex: 0 0 auto;
  overflow: visible;
  cursor: default;
  pointer-events: none;
  &,
  & * {
    cursor: default !important;
  }
  path {
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke-width: 0.2;
    vector-effect: non-scaling-stroke;
  }
`;
IconService.displayName = 'IconService_';

export const Ungroup = styled(UngroupIcon_)`
  margin-right: 11px !important;
  height: 18px;
  width: 18px;
  & path {
    fill: ${({ theme }) => theme.icons.actionBar.color} !important;
    stroke: ${({ theme }) => theme.icons.actionBar.color} !important;
  }
`;
Ungroup.displayName = 'Ungroup';
